import React, { useMemo } from "react";
import { useActionState } from "react";
import { io } from "socket.io-client";

const SocketContext = React.createContext(null);

export const useSocket = () => React.useContext(SocketContext);

export const SocketProvider = (props) => {

    const socket = useMemo(() => io("https://turn.pristine.farm"), [])

    return (
        <SocketContext.Provider value={{ socket }}>
            {props.children}
        </SocketContext.Provider>
    )

}